module.exports = __webpack_public_path__ + "assets/img/thumb-Kent-Street-Cellars-2-Video.f2729bec.jpg";